import { getWalletAdapter } from '@api/FW/adapters/wallets/getWallet.adapter';
import { getQueryParams, httpApi } from '@api/FW/http.api';
import { IWalletItem, WalletItemAdapter } from '@interfaces/FW/Wallets';
import { IWalletSettingsFields } from '@pages/FW/Wallet/Settings/WalletSettings';

export interface WalletRequest {
	type?: number | undefined;
	status?: number;
}

export const getWallet = (
	payload?: WalletRequest,
	counterparty?: string | string[],
): Promise<IWalletItem[]> => {
	const counterparties = Array.isArray(counterparty) ? counterparty.join('/') : counterparty;
	const endpoint = counterparties ? `Wallets/${counterparties}` : 'Wallets';

	return httpApi
		.get<WalletItemAdapter[]>(endpoint, {
			params: { ...getQueryParams(), ...payload },
		})
		.then(({ data }) => {
			return getWalletAdapter(data);
		})
		.catch((err) => {
			throw err;
		});
};

export const modifyWallets = (wallet: string, func: string, param: string | number) => {
	return httpApi
		.post(`ModifyWallets/${wallet}/${func}/${param}/`, undefined, {
			params: getQueryParams(),
		})
		.then(({ data }) => {
			//console.log('modifyWallets', data)
			return data;
		})
		.catch((err) => {
			throw err;
		});
};

/**
 * Update multiple params of the wallet.
 *
 * @param walletId - Wallet GUID.
 * @param params - Updated params.
 */
export const modifyWalletBulk = (walletId: string, params: IWalletSettingsFields) => {
	return httpApi
		.post(
			`ModifyWallets/${walletId}/BulkModify/0/`,
			{
				Name: params.name,
				State: params.state,
				Comment: params.comment,
				Overdraft: params.overdraft,
				SendSMS: params.sendSMS,
				SendEmail: params.sendEmail,
				Print: params.print,
				BanConclusionAdditionalInformationInCheck: params.hideAdditionalCheckInfo,
				MinimumBalanceControlAmount: 0, // TODO: Remove after implementation
			},
			{
				params: getQueryParams(),
			},
		)
		.then(({ data }) => {
			// console.log('modifyWallets', data);
			// return data;
		})
		.catch((err) => {
			throw err;
		});
};

export const addWallet = (title: string, client: string, contract: string, type: string) => {
	return httpApi
		.post(
			`AddWallet/${title}/${client}/${contract}/${type}`,
			{},
			{
				params: getQueryParams(),
			},
		)
		.then(({ data }) => {
			// console.log('AddWallet', data);
			return data.Счет;
		})
		.catch((err) => {
			throw err;
		});
};

export const deleteWallet = (wallet: string) => {
	return httpApi
		.post(
			`DeleteWallet/${wallet}`,
			{},
			{
				params: getQueryParams(),
			},
		)
		.then(({ data }) => {
			// console.log('DeleteWallet', data);
			return data;
		})
		.catch((err) => {
			throw err;
		});
};
